export const UPLOADED_PUBLIC_ASSETS_URL = 'https://public-static-dev.txt2create.com/assets/'
export const LOGIN_SCREEN_VIDEO = 'LoginPageVideo.mp4'